import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import Api from "./../../Hooks/Api"
class Logout extends Component {
  constructor() {
    super();
    this.state = {};
    this.logout = this.logout.bind(this);
  }
  submit = (url) => {
    Api.put(url)
      .then(function (response) {
      })
      .catch(function (error) {
        // handle error

      })
      .then(function () {
        // always executed
      })
  };
  logout = () => {
    let UserId = window.sessionStorage.getItem("UserId");
    let SecurityGroupId = window.sessionStorage.getItem("SecurityGroupId");
    if (SecurityGroupId == "1") {
      let url = "/api/login/" + UserId + "/student";
      Api.put(url)
        .then(function (response) {
        })
        .catch(function (error) {
          // handle error

        })
        .then(function () {
          // always executed
        })


    } else {
      let url = "/api/login/" + UserId + "/users";
      Api.put(url)
        .then(function (response) {
        })
        .catch(function (error) {
          // handle error

        })
        .then(function () {
          // always executed
        })
    }

    window.sessionStorage.clear();
    localStorage.clear();
    return <Redirect to="/" push />;
  };

  clicka = () => {
    document.getElementById("nav-profile-tab").click();
  };
  componentDidMount() {
    this.clicka();
  }

  render() {
    return (
      <a
        id="nav-profile-tab"
        onClick={this.logout}
        href="/"
        className="btn btn-default btn-flat"
      ></a>
    );
  }
}
export default Logout;
